import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-accredited-letter',
  templateUrl: './icon-accredited-letter.component.html'
})
export class IconAccreditedLetterComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
